// These are only examples, this can be updated...

const colors = {
	white: '#ffffff',
	black: 'rgba(0,0,0,0.65)',
	gray: '#A6A6A6',
	lightGray: '#e9e9e9',
	blueFacebook: '#3b5998',
	blue: '#5E9FDF',
	blueLight: '#316394',
	darkGreen: '#2a7267',
  	lightGreen: '#15b0ac',
	green: '#32C760',	
	red: '#E64131',
	redLight:'#E6675B',
	redGoogle:'#DC4E41',
	skyBlue: '#5fdce8',
	error: 'red',
	violet: '#8e0e7f',
	yellow: '#f1a746',
	bloodOrange: '#f1a746',
}

export default colors;





// WEBPACK FOOTER //
// ./src/theme/colors.js